import { Component, OnInit, Inject, AfterViewInit, OnDestroy, ViewChild, HostListener, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CustomerService } from 'src/app/core/services/customer.service';
import { CommonService } from 'src/app/core/services/common.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDatepickerInputEvent, MatSelect, MatAccordion, MatTabGroup } from '@angular/material';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Router } from '@angular/router';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { DeactivationGuarded } from 'src/app/core/guards/confirm-deactivate.guard';
import { UploadMultiFileComponent } from 'src/app/shared/components/upload-multi-file/upload-multi-file.component';
import { Subscription, Subject, ReplaySubject } from 'rxjs';
import { NgForm, FormControl } from '@angular/forms';
import { map, first, takeUntil, finalize } from 'rxjs/operators';
import { DocumentService } from 'src/app/core/services/document.service';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import { ApiService } from 'src/app/core/services/api.service';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { DateFormat } from '../../../../../../../../core/class/date-format';
import { Platform } from '@angular/cdk/platform';
import { CustomerEntity } from 'src/app/core/class/customer-entity';
import { SmsWarningComponent } from 'src/app/shared/components/sms-warning/sms-warning.component';
import { DialogAIRecognitionComponent } from '../../dialog-ai-recognition/dialog-ai-recognition.component';
import { EnumCustomerType, EnumFomatUploadFile, EnumFileTypeUpload } from "src/app/core/constants/common"
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Common } from '../../../../../../../../core/constants/common';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-add-customer-dialog',
  templateUrl: './add-customer-dialog.component.html',
  styleUrls: ['./add-customer-dialog.component.scss'],
  providers: [
    // DateFormat,
    { provide: MAT_DATE_LOCALE, useValue: 'vi' },
    {
      provide: DateAdapter,
      useClass: DateFormat,
      deps: [MAT_DATE_LOCALE, Platform],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class AddCustomerDialogComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, DeactivationGuarded {
  @BlockUI() blockUI: NgBlockUI;
  enumCustomerType = EnumCustomerType;
  timeOutQueryServer = null;
  filteredStates: CustomerEntity[] = [];
  filteredStatesTaxCode: CustomerEntity[] = [];
  isLoadingCerNo = false;
  isLoadingTaxCode = false;

  maxLengthPhone = Common.MAX_LENGTH_PHONE;

  // set max date for birthday
  maxDate = new Date();
  minDate = new Date(1899, 12, 1);
  currentTab = 0;
  isInforTab = 0
  @ViewChild(UploadMultiFileComponent, { read: UploadMultiFileComponent, static: false }) uploadMultiFileComponent;
  @ViewChild('certificationTypeSelect', { static: false }) certificationTypeSelect: MatSelect;
  @ViewChild('representativeCertificateSelect', { static: false }) representativeCertificateSelect: MatSelect;
  @ViewChild('citySelect', { static: false }) citySelect: MatSelect;
  @ViewChild('districtSelect', { static: false }) districtSelect: MatSelect;
  @ViewChild('wardSelect', { static: false }) wardSelect: MatSelect;
  @ViewChild('sexSelect1', { static: false }) sexSelect1: MatSelect;
  @ViewChild('sexSelect2', { static: false }) sexSelect2: MatSelect;
  @ViewChild('accordion', { static: false }) accordion: MatAccordion;
  @ViewChild('myTabGroup', { static: false }) myTabGroup: MatTabGroup;
  @ViewChild('bankSelect', { static: false }) bankSelect: MatSelect;

  createSuccess = new Subject();
  personalId = EnterpriseTypes.PERSONAL;
  customer = {
    enterpriseId: localStorage.getItem('enterpriseId'),
    primaryEmail: null,
    customerType: null,
    name: '',
    status: true,
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    taxCode: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: '',
    representativeIssuedAt: '',
    birthday: null,
    sex: null,
    accountNumber: '',
    accountName: '',
    bankName: '',
    bankBranch: '',
    phone: '',
    fax: '',
    email: '',
    address: '',
    cityId: null,
    wardId: null,
    districtId: null,
    attachments: [],
    groupCustomerIds: [],
    attachmentImages: [],
    isSmsSend: false,
    customerCode:null,
    isNewAddress: true
  };
  oldCustomer = {
    enterpriseId: localStorage.getItem('enterpriseId'),
    primaryEmail: null,
    customerType: null,
    name: '',
    status: true,
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    taxCode: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: '',
    representativeIssuedAt: '',
    birthday: null,
    sex: null,
    accountNumber: '',
    accountName: '',
    bankName: '',
    bankBranch: '',
    phone: '',
    fax: '',
    email: '',
    address: '',
    cityId: null,
    wardId: null,
    districtId: null,
    attachments: [],
    groupCustomerIds: [],
    attachmentImages: [],
    isSmsSend: false,
    customerCode:null,
    isNewAddress: true
  };
  checkFocus = false;
  cities: comboBox[]=[];
  districts: districtsComboBox[]=[];
  selectedDistricts: districtsComboBox[]=[];
  wards: wardsCombobox[]=[];
  selectWards: wardsCombobox[]=[];
  show = true;
  change = false;
  error = '';
  subscription: Subscription;
  events: string[] = [];
  customerId: any;
  isShowInfor: boolean = true
  @ViewChild('f', { static: false }) ngForm: NgForm;
  formChangesSubscription: Subscription;
  isFormChanging = false;
  listBankName: comboBox[] = [];
  bankFilterCtrl: FormControl = new FormControl();

  @ViewChild("focusSelect", {static: false}) focusSelect: MatSelect;
  @HostListener('submit')
  onFormSubmit() {
     const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
      this.onClickBtnCancel();
  }
  /**
   * Check if District hasn't Ward
   */
  notHasWard = false;
  cityList: any[] = [[],[]]
  districtList: any[] = [[],[]]
  wardList: any[] = [[],[]]
  /**
   * Check req expiredDateChange
   */
  checkIssuedDate = true;
  enterpriseType: comboBox[]=[];
  certificateType: comboBox[]=[];
  representativeCertificateType: comboBox[]=[];

  enterpriseTypeFilterCtrl: FormControl = new FormControl();
  certificationTypeFilterCtrl: FormControl = new FormControl();
  representativeCertificateTypeFilterCtrl: FormControl = new FormControl();
  cityFilterCtrl: FormControl = new FormControl();
  districtsFilterCtrl: FormControl = new FormControl();
  wardFilterCtrl: FormControl = new FormControl();
  urlApi = '/customer/add';
  userType: any;
  entType: any;
  permissions: any
  oldCustomerType: any = 0;
  listImage: any[] = [
    {
      fileType: EnumFileTypeUpload.IMAGE_FRONT,
      fileName: '',
      fileContentBase64: '',
      fileTitle:  this.message.getMessage('kyc.image_front'),
      fileSize: 0,
      error: 0,
      accept: EnumFomatUploadFile.UPLOAD_FILE_IMAGE,
    },
    {
      fileType: EnumFileTypeUpload.IMAGE_BACK,
      fileName: '',
      fileContentBase64: '',
      fileTitle:  this.message.getMessage('kyc.image_back'),
      fileSize: 0,
      error: 0,
      accept: EnumFomatUploadFile.UPLOAD_FILE_IMAGE,
    },
    {
      fileType: EnumFileTypeUpload.AVATAR,
      fileName: '',
      fileContentBase64: '',
      fileTitle:  this.message.getMessage('kyc.customer_avatar'),
      fileSize: 0,
      error: 0,
      accept: EnumFomatUploadFile.UPLOAD_FILE_IMAGE,
    },
    {
      fileType: EnumFileTypeUpload.BUSINESS_LICENSE_FRONT,
      fileName: '',
      fileContentBase64: '',
      fileTitle:  this.message.getMessage('kyc.business_license_front'),
      fileSize: 0,
      error: 0,
      accept: EnumFomatUploadFile.UPLOAD_FILE,
    },
    {
      fileType: EnumFileTypeUpload.BUSINESS_LICENSE_BACK,
      fileName: '',
      fileContentBase64: '',
      fileTitle:  this.message.getMessage('kyc.business_license_back'),
      fileSize: 0,
      error: 0,
      accept: EnumFomatUploadFile.UPLOAD_FILE,
    },
  ];
  scopeType:number;
  public filteredWard: ReplaySubject<wardsCombobox[]> = new ReplaySubject<wardsCombobox[]>(1);
  public filteredDistricts: ReplaySubject<districtsComboBox[]> = new ReplaySubject<districtsComboBox[]>(1);
  public filteredCity: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredEnterpriseType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredCertificationType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredRepresentativeCertificateType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredBankName: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);

  private _onDestroy = new Subject<void>();

  constructor(
    // public dialogRef: MatDialogRef<AddCustomerComponent>,
    private apiService: ApiService,
    private el: ElementRef,
    public commonService: CommonService,
    private customerService: CustomerService,
    public notificationService: NotificationService,
    private dialog: MatDialog,
    private router: Router,
    private breadcrumbsService: BreadcrumbsService,
    public message: Message,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<AddCustomerDialogComponent>, @Inject(MAT_DIALOG_DATA) public isDialog: boolean,
    public documentService: DocumentService,
    private translate: TranslateService,
    private _adapter: DateAdapter<any>,
    private cdr: ChangeDetectorRef,
  ) {
    super(commonService, message);
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onClickBtnCancel();
    });
    this.setDefaultLanguage();
    this.scopeType = this.commonService.checkEnterpriseType() ? 2 : 1;
  }

  /**
   * Get initial data
   */
  ngOnInit() {
    this.userType = Number(localStorage.getItem("userType"));
    this.entType = Number(localStorage.getItem("entType"));
    this.permissions = JSON.parse(localStorage.getItem("permissions"));
    this.apiService.addUrlToHandlingErrorRestApis(this.urlApi);
    this.enterpriseTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {this.commonService.filterCertificateType(this.enterpriseType, this.enterpriseTypeFilterCtrl,this.filteredEnterpriseType);});
    this.certificationTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {this.commonService.filterCertificateType(this.certificateType, this.certificationTypeFilterCtrl,this.filteredCertificationType);});
    this.representativeCertificateTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {this.commonService.filterCertificateType(this.representativeCertificateType, this.representativeCertificateTypeFilterCtrl,this.filteredRepresentativeCertificateType);});
    this.cityFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {this.commonService.filterCertificateType(this.cities, this.cityFilterCtrl,this.filteredCity);});
    this.districtsFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {this.commonService.filterCertificateType(this.selectedDistricts, this.districtsFilterCtrl,this.filteredDistricts);});
    this.wardFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {this.commonService.filterCertificateType(this.selectWards, this.wardFilterCtrl,this.filteredWard);});
    this.bankFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.commonService.filterCertificateType(this.listBankName, this.bankFilterCtrl, this.filteredBankName);
    });
    this.getBankName();
    this.getEnterpriseType();
    this.getCertificateType();
    this.getRepresentativeCertificateType();
    this.loadCities();
    this.loadDistricts();
    this.loadWards();
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
    if (!this.isDialog) {
      this.breadcrumbsService.store([
        { label: 'breadcrumbs.home', url: 'main', params: [], highlight: false },
        { label: 'breadcrumbs.enterprise_customer', url: 'customers', params: [], highlight: false },
        { label: 'breadcrumbs.customer_add', url: 'add-customer', params: [], highlight: false },
      ]);
    }
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusSelect.focused = true);
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.formChangesSubscription.unsubscribe();
    this.apiService.removeUrlToHandlingErrorRestApis();
  }

  /**
   * Detect change on city or district combobox
   */
  onChange(value: number, opt: number = 1) {
    switch (opt) {
      case 1:
        this.selectedDistricts = this.districts.filter(x => {
          this.selectWards = null;
          this.customer.districtId = null;
          this.customer.wardId = null;
          return x.cityId === value;
                });
        this.filteredDistricts.next(this.selectedDistricts.slice());
        this.filteredWard = new ReplaySubject<wardsCombobox[]>(1);
        break;
      case 2:
        this.selectWards = this.wards.filter(x => {
          this.customer.wardId = null;
          if(this.customer.isNewAddress){
            return x.cityId === value;
          } else {
            return x.districtId === value;
          }
        });
        this.filteredWard.next(this.selectWards.slice());
        if (this.selectWards.length === 0) {
          this.notHasWard = true;
        } else {
          this.notHasWard = false;
        }
        break;
      default:

        break;
    }
  }

  /**
   * On click button add customer
   */

   onAddCustomer(){
     const hasAttachment = this.listImage.some(el => el.fileContentBase64 && el.fileContentBase64.length > 0);
    if(this.listImage && this.listImage.length > 0 && hasAttachment){
      this.listImage = this.listImage.filter(item => {
        if(item.fileContentBase64 && (this.customer.customerType == EnumCustomerType.PERSONAL ? item.fileType == EnumFileTypeUpload.IMAGE_FRONT || item.fileType == EnumFileTypeUpload.IMAGE_BACK || item.fileType == EnumFileTypeUpload.AVATAR : item.fileType == EnumFileTypeUpload.BUSINESS_LICENSE_FRONT || item.fileType == EnumFileTypeUpload.BUSINESS_LICENSE_BACK)){
          return item
        }
      })
      this.customerService.uploadImage(this.listImage).subscribe(res => {
        if(res && res.success){
          this.customer.attachmentImages = res.data;
          this.addAttachments();
        }else{
          this.toastr.error(res.message)
        }
      })
    }else{
      this.addAttachments();
    }
  }

  imageUpload($event){
    this.listImage = $event;
    this.isFormChanging = true;
    }

  addAttachments() {
    this.uploadMultiFileComponent.uploadFile((attachments) => {
      this.customer.attachments = attachments;
      this.addCustomer();
    }, () => {
      this.addCustomer();
    });
  }

  /**
   * Call create customer service and push data to server.
   */
  private addCustomer() {
      if(this.entType==2){
        delete this.customer.isSmsSend
      }
    this.customerService.createCustomer(this.customer, this.onAddCustomerError.bind(this))
      .subscribe(rs => {
        if (rs.success){
          this.documentService.setCustomerId(rs.data);
          this.show = false;
          this.toastr.success(this.message.getMessage('messages.add_success'));
          this.dialogRef.close();
          // this.customerService.createSuccess.next();
          this.createSuccess.next();
        }
      });
  }

  private onAddCustomerError(rs: any) {
    if (!rs.success) {
      switch (rs.code) {
        case '0x00118':
          this.certificateNoExistingHanlder();
          break;
        case '0x00117':
          this.taxNoExistingHanlder();
          break;
        case '0x010092':
          this.smsWarningHandler();
          break;
        case '0x00133':
          this.existedCustomerCode();
          break;
        default: {
          this.toastr.error(rs.message)
        }
      }
    }
  }

  private certificateNoExistingHanlder(): void {
    if (this.customer.customerType == this.personalId){
      this.ngForm.form.controls.certificateNo1.setErrors({ duplicate: true });
      document.getElementById('certificateNo1').focus();
    } else {
      this.ngForm.form.controls.certificateNo.setErrors({ duplicate: true });
      document.getElementById('certificateNo').focus();
    }
  }

  private existedCustomerCode(): void {
    if (this.customer.customerCode == this.personalId) {
      this.ngForm.form.controls.customerCode.setErrors({ duplicate: true });
      document.getElementById('customerCode').focus();
    } else {
      this.ngForm.form.controls.customerCode.setErrors({ duplicate: true });
      document.getElementById('customerCode').focus();
    }
  }
  private taxNoExistingHanlder(): void {
    this.ngForm.form.controls.taxCode.setErrors({ duplicate: true });
    document.getElementById('taxCode').focus();
  }

  private smsWarningHandler(): void{
    const dialogRe = this.dialog.open(SmsWarningComponent, {
      width: '500px',
      data: this.message.getMessage('messages.sms_warning')
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        this.customer ={...this.customer,isSmsSend:false};
        this.addCustomer()
      }else{
        dialogRe.close();
      }
    });
  }

  /**
   * Back to list customers
   */
  onNoClick(): void {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          this.router.navigate(['/home-enterprise/customers'], {
          });
        }
        dialogRe.close();
      });
    } else {
      this.router.navigate(['/home-enterprise/customers'], {
      });
    }
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    if ((this.isFormChanging && this.show) || (this.uploadMultiFileComponent.isFormChanging && this.show) || (this.change && this.show)) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    } else {
      return true;
    }
  }

  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.change = true;
  }

  /**
   * Event when click button cancel
   */
  onClickBtnCancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Get cities list from local storage or api
   */
  private loadCities() {
    // if (localStorage.getItem('cities') === null) {
      this.commonService.getAllCityRedis().subscribe(rs => {
        this.cityList[1] = rs.data.filter(item => !item.isNew);
        localStorage.setItem(
          'cities',
          JSON.stringify(this.cityList[1]),
        );
      });
      
      this.commonService.getAllCityRedis('?type=NEW').subscribe(rs => {
        this.cityList[0] = rs.data.filter(item => item.isNew);
        this.cities = this.cityList[0];
        this.filteredCity.next(this.cities.slice());
      });
    // } else {
    //   this.cities = JSON.parse(
    //     localStorage.getItem('cities')
    //   );
    //   this.filteredCity.next(this.cities.slice());
    // }
  }

  /**
   * Get districts list from local storage or api
   */
  private loadDistricts() {
    // if (localStorage.getItem('districts') === null) {
      this.commonService.getAllDistrictsRedis().subscribe(rs => {
        this.districts = rs.data;
        this.districtList[0] = [];
        this.districtList[1] = rs.data;
        localStorage.setItem(
          'districts',
          JSON.stringify(this.districts),
        );
        this.districts = this.districtList[0]
      });
    // } else {
    //   this.districts = JSON.parse(
    //     localStorage.getItem('districts')
    //   );
    // }
  }

  /**
   * Get wards list from local storage or api
   */
  private loadWards() {
    // if (localStorage.getItem('wards') === null) {
      this.commonService.getAllWardRedis().subscribe(rs => {
        this.wardList[1] = rs.data.filter(item => !item.isNew);
        localStorage.setItem(
          'wards',
          JSON.stringify(this.wardList[1]),
        );
      });

      this.commonService.getAllWardRedis('?type=NEW').subscribe(rs => {
        this.wardList[0] = rs.data.filter(item => item.isNew);
        this.wards = this.wardList[0];
      });
    // } else {
    //   this.wards = JSON.parse(
    //     localStorage.getItem('wards')
    //   );
    // }
  }

  getBankName() {
    this.commonService.getBankName().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.listBankName = result;
        this.filteredBankName.next(this.listBankName.slice());
      }
    });
  }

  /**
   * Get wards list from local storage or api
   */
  getEnterpriseType() {
    this.commonService.getEnterpriseType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.enterpriseType = result;
        this.filteredEnterpriseType.next(this.enterpriseType.slice());
      }
      if (this.enterpriseType.length > 0) {
        const personal = this.enterpriseType.find(t => String(t.id) === String(EnumCustomerType.PERSONAL));
        this.customer.customerType = personal ? personal.id : this.enterpriseType[0].id;
      }
    });
  }

  /**
   * Get certificate list
   */
  getCertificateType() {
    this.commonService.getCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.certificateType = result;
        this.filteredCertificationType.next(this.certificateType.slice());
      }
    });
  }

  /**
   * Get representative certificate list
   */
  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.representativeCertificateType = result;
        this.filteredRepresentativeCertificateType.next(this.representativeCertificateType.slice());
      }
      if (this.certificateType.length > 0) {
        const CCCDID = this.representativeCertificateType.find(item => item.id == '30002') || '';
        this.customer.certificateId =  CCCDID ? CCCDID.id :  this.representativeCertificateType[0].id;
      }
      if (this.representativeCertificateType.length > 0) {
        const CCCDID = this.representativeCertificateType.find(item => item.id == '30002') || '';
        this.customer.representativeCertificateId =  CCCDID ? CCCDID.id :  this.representativeCertificateType[0].id;
      }
    });
  }

  /**
   * change RepresentativeCertificateType when edit custumertype
   */
  changeRepresentativeCertificateType() {
    if (this.enterpriseType.length > 0) {
      if (this.customer.customerType == EnumCustomerType.PERSONAL) {
        if (this.certificateType.length > 0) {
          setTimeout(()=> {
            const CCCDID = this.representativeCertificateType.find(item => item.id == '30002') || '';
            this.customer.certificateId = CCCDID ? CCCDID.id : this.representativeCertificateType[0].id;
          },100)
        }
      } else {
        if (this.certificateType.length > 0) {
          setTimeout(()=> {
            this.customer.certificateId = this.certificateType[0].id;
          },100)
        }
        if (this.representativeCertificateType.length > 0) {
          setTimeout(()=> {
            const CCCDID = this.representativeCertificateType.find(item => item.id == '30002') || '';
            this.customer.representativeCertificateId = CCCDID ? CCCDID.id :  this.representativeCertificateType[0].id;
          },100)
        }
      }
    }
    this.filteredStatesTaxCode = [];
    this.filteredStates = [];
  }

  /**
   * Check req for checkIssuedDate
   */
  checkIssuedDateChange(value) {
    if (value == null || value == '' || value == undefined) {
      this.checkIssuedDate = true;
    } else {
      this.checkIssuedDate = false;
    }
  }

  onAttachmentChange(event) {
    this.isFormChanging = event;
  }

  setDefaultLanguage() {
    if (this.getLanguagelocalStored() === null) {
      this.translate.setDefaultLang('vi');
      this.setLanguagelocalStored('vi');
      this._adapter.setLocale('vi');
    } else {
      this.translate.setDefaultLang(this.getLanguagelocalStored());
      this._adapter.setLocale(this.getLanguagelocalStored());
    }
  }

  onChangeType() {
    if (this.oldCustomerType == EnumCustomerType.PERSONAL && this.customer.customerType > EnumCustomerType.PERSONAL || this.customer.customerType == EnumCustomerType.PERSONAL && this.oldCustomerType > EnumCustomerType.PERSONAL) {
      this.customer.taxCode = '';
      this.customer.certificateId = null;
    }
    this.oldCustomerType = this.customer.customerType;
  }


  onSelectionChangeCertificate(event, inputType) {
    if (event.option) {
      let parseObj;
      if (inputType === 'taxCode') {
        parseObj = this.filteredStatesTaxCode[0];
        this.filteredStates = [];
      } else {
        parseObj = this.filteredStates[0];
        this.filteredStatesTaxCode = []
      }
      this.customer.name = parseObj.name ? parseObj.name : '';
      this.customer.address = parseObj.address ? parseObj.address : '';
      this.customer.email = parseObj.email ? parseObj.email : '';
      this.customer.phone = parseObj.phone ? parseObj.phone : '';
      this.customer.taxCode = parseObj.taxCode ? parseObj.taxCode : '';
      this.customer.certificateNo = parseObj.certificateNo ? parseObj.certificateNo : '';
      this.customer.customerType = parseObj.customerType ? parseObj.customerType : this.personalId;
      if (this.customer.wardId === undefined || this.customer.wardId == null) {
        this.customer.cityId = null;
        this.customer.wardId = null;
        this.customer.districtId = null;
      } else {
        this.selectedDistricts = this.districts.filter(x => {
          return x.cityId == this.customer.cityId;
        });
        this.filteredDistricts.next(this.selectedDistricts.slice());
        this.selectWards = this.wards.filter(x => {
          return x.districtId == this.customer.districtId;
        });
        this.filteredWard.next(this.selectWards.slice());
      }
      // this.attachments = [...this.customer.attachments];
    }
  }

  changeCertificate($event, inputType) {
    if (inputType === 'taxCode') {
      this.filteredStatesTaxCode = [];
    } else {
      this.filteredStates = [];
    }
    if ($event.inputType.includes('insert') || $event.inputType.includes('delete')) {
      if (this.timeOutQueryServer) {
        clearTimeout(this.timeOutQueryServer);
      }
      this.timeOutQueryServer = setTimeout(() => {
        if (this.customer.certificateNo.trim().length > 0 || this.customer.taxCode.trim().length > 0) {
          let valueSearch = '';
          if (inputType === 'taxCode') {
            this.isLoadingTaxCode = true;
            valueSearch = this.customer.taxCode.trim();
          } else {
            this.isLoadingCerNo = true;
            valueSearch = this.customer.certificateNo.trim();
          }
          this.customerService.fetchAuto(valueSearch, this.customer.customerType).then(result => {
            if (inputType === 'taxCode') {
              this.filteredStatesTaxCode = [];
            } else {
              this.filteredStates = [];
            }
            if (result) {
              for (const item of result) {
                if (inputType === 'taxCode') {
                  this.filteredStatesTaxCode.push(item);
                } else {
                  this.filteredStates.push(item);
                }
              }
            }
          }).finally(() => {
            this.isLoadingCerNo = false;
            this.isLoadingTaxCode = false;
          })
        } else {
          if (inputType === 'taxCode') {
            this.customer.taxCode = '';
            this.filteredStatesTaxCode = [];
          } else {
            this.customer.certificateNo = '';
            this.filteredStates = [];
          }
        }
      }, 500)
    }
  }

  clearTaxCode() {
    this.customer.taxCode='';
    this.filteredStatesTaxCode = [];
  }

  clearCerNo() {
    this.customer.certificateNo='';
    this.filteredStates = [];
  }

  onChangeGroupCustomerIds(event){
    this.customer.groupCustomerIds = event;
    this.isFormChanging = true
  }

  isInvalidForm(){
    this.accordion.openAll();
    this.myTabGroup.selectedIndex = 0;
    this.ngForm.form.markAllAsTouched();
    this.ngForm.form.markAsDirty()
  }

  cutSpace(){
    this.customer.customerCode = this.customer.customerCode.replace(/\s/g,'')
  }

  convertPhone(str: string): string {
    return str.replace(/\s/g, '');
  }

  convertIssuedAt(str: string): string {
    return str.substring(0, 100);
  }

  convertStringAi(str: string, num:number): string {
    return str.substring(0, num);
  }

  openPopupRecognitionAI() {
    const dialogRef = this.dialog.open(DialogAIRecognitionComponent, {
      width: '650px',
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.customer = { ...this.oldCustomer };
        if(!rs.data.isNewAddress){
          this.cities = this.cityList[1]
          this.districts = this.districtList[1]
          this.wards = this.wardList[1]
          this.filteredCity.next(this.cities.slice());
          this.onChange(rs.data.cityId, 1);
          this.onChange(rs.data.districtId, 2);
        } else {
          this.cities = this.cityList[0]
          this.districts = this.districtList[0]
          this.wards = this.wardList[0]
          this.filteredCity.next(this.cities.slice());
          this.onChange(rs.data.cityId, 2);
        }
        const dataCustomer = rs.data;
        if (rs.data.birthday) {
          dataCustomer.birthday = new Date(rs.data.birthday);
        }
        if (rs.data.issuedDate) {
          dataCustomer.issuedDate = new Date(rs.data.issuedDate);
        }
        if (rs.data.phone) {
          dataCustomer.phone = this.convertPhone(dataCustomer.phone);
        }
        if (rs.data.issuedAt) {
          dataCustomer.issuedAt = this.convertIssuedAt(dataCustomer.issuedAt);
        }
        if (rs.data.address) {
          dataCustomer.address = this.convertStringAi(dataCustomer.address, 200);
        }
        if (rs.data.name) {
          dataCustomer.name = this.convertStringAi(dataCustomer.name, 200);
        }
        if (rs.data.representative) {
          dataCustomer.representative = this.convertStringAi(dataCustomer.representative, 200);
        }
        if (rs.data.position) {
          dataCustomer.position = this.convertStringAi(dataCustomer.position, 200);
        }
        if(dataCustomer.customerType !== EnumCustomerType.PERSONAL && rs.data.representativeIssuedDate) {
          dataCustomer.representativeIssuedDate = new Date(rs.data.representativeIssuedDate);
        }
        this.listImage = [...this.listImage.map((image) => ({
          ...image,
          typeDisplay: image.fileType === EnumFileTypeUpload.BUSINESS_LICENSE_FRONT || image.fileType === EnumFileTypeUpload.BUSINESS_LICENSE_BACK ? 'enterprise' : 'personal',
          fileContentBase64: image.fileType == EnumFileTypeUpload.IMAGE_FRONT || image.fileType === EnumFileTypeUpload.BUSINESS_LICENSE_FRONT ? rs.listImageUpload[0].fileContentBase64 : image.fileType == EnumFileTypeUpload.IMAGE_BACK || image.fileType === EnumFileTypeUpload.BUSINESS_LICENSE_BACK ? rs.listImageUpload[1].fileContentBase64 : image.fileContentBase64,
          fileName: image.fileType == EnumFileTypeUpload.IMAGE_FRONT || image.fileType === EnumFileTypeUpload.BUSINESS_LICENSE_FRONT ? rs.listImageUpload[0].fileName : image.fileType == EnumFileTypeUpload.IMAGE_BACK || image.fileType === EnumFileTypeUpload.BUSINESS_LICENSE_BACK ? rs.listImageUpload[1].fileName : image.fileName,
          fileSize: image.fileType == EnumFileTypeUpload.IMAGE_FRONT || image.fileType === EnumFileTypeUpload.BUSINESS_LICENSE_FRONT ? rs.listImageUpload[0].fileSize : image.fileType == EnumFileTypeUpload.IMAGE_BACK || image.fileType === EnumFileTypeUpload.BUSINESS_LICENSE_BACK ? rs.listImageUpload[1].fileSize : image.fileSize,
        }))];
        this.customer = {...this.customer, ...dataCustomer};
      } else {
        dialogRef.close();
      }
    });
  }

  changeAddress(event: boolean){
    if(this.customer.isNewAddress == event){
      return
    } 
    this.customer.isNewAddress = event
    
    if(event){
      this.cities = this.cityList[0]
      this.districts = this.districtList[0]
      this.wards = this.wardList[0]
      if(!(!this.customer.cityId && !this.customer.districtId && !this.customer.wardId)){
        this.blockUI.start()
        const id = this.customer.wardId ? this.customer.wardId : this.customer.districtId ? this.customer.districtId : this.customer.cityId
        this.customer.cityId = null
        this.customer.districtId = null
        this.customer.wardId = null
        this.onChange(null, 2)
        this.commonService.changeNewAddress(id).pipe(finalize(()=> this.blockUI.stop())).subscribe(res =>{
          console.log(res, res.data._return.lstProductSpecCharDTOs);
          if(res.success){
            if(res.data._return.lstProductSpecCharDTOs && res.data._return.lstProductSpecCharDTOs.length > 0){
              this.customer.cityId = res.data._return.lstProductSpecCharDTOs[0].province;
              this.onChange(this.customer.cityId, 2)
              if(res.data._return.lstProductSpecCharDTOs[0].precinct){
                this.customer.wardId = this.customer.cityId + res.data._return.lstProductSpecCharDTOs[0].precinct;
              }
            }
          } else {
            this.toastr.error(res.message)
          }
        })
      } else {
        this.onChange(null, 2)
      }
    } else {
      this.cities = this.cityList[1]
      this.districts = this.districtList[1]
      this.wards = this.wardList[1]
      this.customer.cityId = null
      this.customer.districtId = null
      this.customer.wardId = null
      this.onChange(null)
    }
    this.cityFilterCtrl.patchValue('')
    this.districtsFilterCtrl.patchValue('')
    this.wardFilterCtrl.patchValue('')
  }
}


